<template>
  <div class="no_spaces_for_div col-12 col-md-12 col-lg-12" v-if="is_load">
    <router-link  v-if="!(user.isanonymous && user.isanonymous==true)"  tag="a"
                 :to="{name: route_name, params: { user_id: user.last_id }}" >
      <div class="card-user card ">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4 col-md-3">
              <img :src="image_url+user.avatar" alt="Avatar" class="img-fluid rounded-circle card-user-avatar">
            </div>
            <div class="col-sm-8 col-md-9">
              <h5 class="card-title developer_name">{{ user.name }}</h5>

            </div>
          </div>
        </div>
      </div>

    </router-link>
    <div class="card-user card " v-if="(user.isanonymous && user.isanonymous==true)">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-3">
            <img :src="image_url+user.avatar" alt="Avatar" class="img-fluid rounded-circle card-user-avatar">
          </div>
          <div class="col-sm-8 col-md-9">
            <h5 class="card-title developer_name">{{ user.name }}</h5>

            <p v-if="user.description" v-on:click.stop.prevent="openLinkParagraph" v-html="parsed_text"> </p>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>
import Vue from "vue";

export default {
  name:"UserCard",
  props: {
    user:{
      type:Object,
      required:true,
    },
    route_name: {
      type: String,
      required:false,
      default: 'user_page_main',
    },
  },
  data(){
    return {
      'image_url':"",
      'parsed_text':"",
      "is_load":false,
    };
  },
  methods:{
    openLinkParagraph(e){
      e.preventDefault();
      if(e.target.href){
        this.openLink(e.target.href,e);
      }



    },
    openLink(url,e){
      if(e){
        e.preventDefault();
      }
      var base_url=Vue.config.BASE_URL_FRONT;
      const parse_base_url=new URL(base_url);
      const parse_url = new URL(url);



      if(parse_url.hostname==parse_base_url.hostname){
        this.$router.push(parse_url.pathname);

      }else {
        //document.location.href=url;
        window.open(url, '_blank').focus();
      }

      return false;
    },
    startParseText(){
      var app=this;
      if(app.user.description && app.user.description.length>0 ){
        const elem = app.user.description;

        app.parsed_text=elem.replace(/(https?:\/\/[^\s]+)/g, `<a class='mark' href="$1">$1</a>`)

      }
      app.is_load=true;

    },
  },
  mounted() {
    var app=this;
    app.image_url = Vue.config.IMAGE_URL;
    app.startParseText();

  },
}
</script>

<style scoped>

.card-user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>